import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatButton } from "@angular/material/button";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInput } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { PropertyAdditionalOwnerComponent } from "../property-additional-owner/property-additional-owner.component";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { EnrollmentRentalPropertyModel } from "../../domain/models/enrollment-rental-property.model";
import { PropertyOwnerModel } from "../../domain/models/property-owner.model";
import { EnrollmentModel } from "../../domain/models/enrollment.model";
import { RentalPropertyInfoComponent } from "../rental-property-info/rental-property-info.component";
import { EnrollmentComponent } from "../enrollment-request/EnrollmentComponent";
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-enrollment-rental-property',
  standalone: true,
  imports: [
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatRadioModule,
    ReactiveFormsModule,
    PropertyAdditionalOwnerComponent,
    MatButton,
    MatTooltipModule,
    MatIcon,
    MatCheckboxModule,
    RentalPropertyInfoComponent
  ],
  templateUrl: './enrollment-rental-property.component.html',
  styleUrl: './enrollment-rental-property.component.css'
})
export class EnrollmentRentalPropertyComponent implements OnChanges, OnInit, EnrollmentComponent {
  @Input() property!: EnrollmentRentalPropertyModel;
  @Input() owners!: PropertyOwnerModel[];
  @ViewChild(RentalPropertyInfoComponent) rentalPropertyInfoComponent!: RentalPropertyInfoComponent;
  @ViewChild(PropertyAdditionalOwnerComponent) propertyAdditionalOwnerComponent!: PropertyAdditionalOwnerComponent;
  propertyForm!: FormGroup;


  constructor(private fb: FormBuilder) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.init();
  }

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.buildForm(this.property);
  }

  buildForm(info: EnrollmentRentalPropertyModel | undefined): void {
    const digitalPlatform = !info?.useDigitalPlatform ? info?.digitalPlatform : '';
    this.propertyForm = this.fb.group({
      usePlatformForRent: [info?.useDigitalPlatform ?? false],
      digitalPlatform: [{ value: digitalPlatform, disabled: info?.useDigitalPlatform }],
    });

    this.propertyForm.get('usePlatformForRent')?.valueChanges.subscribe((usePlatform) => {
      const digitalPlatformControl = this.propertyForm.get('digitalPlatform');
      if (usePlatform) {
        digitalPlatformControl?.disable();
      } else {
        digitalPlatformControl?.enable();
      }

    })
  }

  public getUpdatedEnrollment(): EnrollmentModel {
    const formValues = this.propertyForm.value;

    return {
      enrollmentRentalProperty: {
        ...this.rentalPropertyInfoComponent.getFormData(),
        useDigitalPlatform: formValues.usePlatformForRent,
        digitalPlatform: formValues.digitalPlatform,
      },
      owners: this.propertyAdditionalOwnerComponent.getOwners(),
    };

  }

  raiseFormValidations(): void {
    this.propertyForm.markAllAsTouched();
    this.rentalPropertyInfoComponent.raiseFormValidations();
  }

  isFormValid() {
    return this.propertyForm.valid
      && this.rentalPropertyInfoComponent.isFormValid();
  }

}




